module.exports = __webpack_public_path__ + "static/media/MerchantIconGrey.37bf8adc.svg";